@if (campagne) {
  <div class="campagne-detail">
    <div  class="campagne-actions">
      @if (connectedUser == campagne.mj._id) {
        <button class="btn btn-primary" (click)="editCampagne()">Éditer</button>
      }
      @if (connectedUser == campagne.mj._id) {
        <button class="btn btn-danger" (click)="deleteCampagne()">Supprimer</button>
      }
      @if (connectedUser == campagne.mj._id) {
        <button class="btn btn-secondary" (click)="addPnjToCampagne()">Ajouter un PNJ</button>
      }
      <button class="btn btn-info" (click)="addNoteToCampagne()">Ajouter une note</button>
    </div>
    <h1>{{ campagne.name }}</h1>
    <p><strong>Maître du Jeu :</strong> {{ campagne.mj.name }}</p>
    <!-- Section pour l'état et les dates de la campagne -->
    <div class="campagne-info">
      <p><strong>État :</strong> {{ campagne.etat }}</p>
      <p><strong>Date de début :</strong> {{ campagne.dateDebut | date:'longDate':'Europe/Paris' }}</p>
      @if (campagne.dateFin) {
        <p><strong>Date de fin :</strong> {{ campagne.dateFin | date:'longDate':'Europe/Paris' }}</p>
      }
    </div>
    <!-- Section pour les personnages joueurs -->
    <div class="personnages-joueurs">
      <h2>Personnages Joueurs</h2>
      <ul>
        @for (pj of campagne.personnagesJoueurs; track pj) {
          <li>
            {{ pj.name }}
          </li>
        }
      </ul>
    </div>
    <!-- Section pour les PNJs -->
    <div class="pnjs">
      <h2>PNJs</h2>
      <ul>
        @for (pnj of campagne.pnjs; track pnj) {
          <li>
            {{ pnj }} @if (pnj) {
            <span>(Visible)</span>
          }
        </li>
      }
    </ul>
  </div>
  <!-- Speech de la campagne -->
  <div class="campagne-speech">
    <h2>Speech</h2>
    <p [innerHTML]="campagne.speech"></p>
  </div>
  <div class="notes-container">
    <h2>Notes</h2>
    @for (note of campagne.notes; track note) {
      @if (canSeeNote(note)) {
        <div class="note-card">
          <div class="note-header">
            <strong>{{ note.auteur.name }}</strong>
            <span class="badge" [ngClass]="{'badge-public': note.type === 'public', 'badge-restricted': note.type === 'restreint', 'badge-private': note.type === 'prive'}">
              {{ note.type }}
            </span>
          </div>
          <p [innerHTML]="note.texte"></p>
        </div>
      }
    }
  </div>
</div>
}

